import {
  Slider,
  Typography,
} from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './VizzleSlider.scss';

const defaultProps = {
  className: '',
  label: '',
  value: 0,
  min: 0,
  max: 10,
  name: '',
};
const VizzleSlider = (props) => {
  const {
    className,
    label,
    value,
    min,
    max,
    name,
    onChange,
    onChangeCommitted,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className='vizzle-slider' data-test={`vizzle-slider-${name}`} {...rest}>
      {label && (
        <Typography gutterBottom className='label' data-test='label'>
          {label}
        </Typography>
      )}

      <Slider
        aria-labelledby='discrete-slider'
        valueLabelDisplay='auto'
        aria-label={label || name || 'vizzle-slider'}
        marks
        min={min}
        max={max}
        className={`${className} slider`}
        value={value}
        onChange={onChange}
        onChangeCommitted={onChangeCommitted}
        data-test={`slider-${name}`}
        {...rest}
        inputProps={{
          'aria-label': label || name || 'vizzle-slider',
        }}
      />
      <div className='value' data-test='vizzle-slider-value'>
        {value}
      </div>
      <div className='range'>
        (
        {min}
        &nbsp;
        -
        &nbsp;
        {max}
        )
      </div>
    </div>
  );
};

export default VizzleSlider;
